module.exports = __webpack_public_path__ + "static/media/Document.eac0f035.svg";